<template>
  <div>
    <SurveyResultComponent
      companyName="Agence du numérique"
      :reference="globalReferenceData"
      :surveySession="surveySessionData"
      />
  </div>
</template>

<script>

import SurveyResultComponent from '@/components/SurveyResult.vue';
import globalReferenceData from '@/assets/mock/reference-global.mock.json';
import surveySessionData from '@/assets/mock/survey.mock.json';

/* eslint-disable no-console */
export default {
  name: 'SurveyResult',
  data() {
    return {
      globalReferenceData,
      surveySessionData,
    };
  },
  components: {
    SurveyResultComponent,
  },
};
</script>
